export default "__VITE_ASSET__38d86b09__"